document.addEventListener('DOMContentLoaded', function () {

  const outerContainer = document.querySelector('#shopify-block-forms_inline_pEyVfc');
    if (outerContainer) {
        outerContainer.style.opacity = '0';
        outerContainer.style.transition = 'opacity 0.5s ease';
    } else {
    }

function checkAndInitializeForm() {
        const formEmbed = document.querySelector('form-embed#app-embed');
        if (formEmbed && formEmbed.shadowRoot) {
            initializeForm(formEmbed.shadowRoot);
        } else {
            setTimeout(checkAndInitializeForm, 100);
        }
    }



    function initializeForm(shadowRoot) {
        try {


            // Your existing style modifications
            const style = document.createElement('style');
            style.textContent = `
                :host {
                    --form-field-border: 0 0 0 1px #2B2B2B;
                    --form-background-color: transparent;
                    --form-text-color: #2B2B2B;
                    --form-placeholder-color: #2B2B2B;
                    --form-field-border-radius: 26px;
                    --forms-body-font: normal 700 1.4rem sofia-pro, sans-serif;
                    --forms-heading-font: normal 700 1.4rem sofia-pro, sans-serif;
                    --forms-button-font: normal 700 1.4rem sofia-pro, sans-serif;
                    --button-border-radius: 26px;
                    --forms-padding-left: 0rem;
                    --forms-padding-right: 0rem;
                    --forms-padding-bottom: 1.83333333333rem;
                    --text-area-column-span: span 2;
                    --input-column-span: span 2;
                    --form-field-padding: 1.5rem !important;
                    --form-field-padding-top: 2rem !important;
                    --form-field-padding-bottom: 0.8rem !important;
                    --inline-container-max-width: 72.6rem;
                    --button-background-color-hovered-modifier: opacity(100%);
                    --min-form-width: 0;
                }

                @media screen and (min-width: 600px) and (max-width: 750px) {
                    :host {
                        --submit-button-width: 33%;
                        --text-area-column-span: span 2;
                        --input-column-span: span 1;
                    }
                }
            
                @media screen and (min-width: 750px) {
                    :host {
                        --forms-padding-left: 0rem;
                        --forms-padding-right: 0rem;
                        --submit-button-width: 25%;
                        --text-area-column-span: span 2;
                        --input-column-span: span 1;
                    }      
                }

                @media screen and (max-width: 490px) {
                    :host {
                        --form-block-display: block;
                    }      
                }                        
            
                button._formSubmitButton_1ll8d_81:focus-visible,
                button._formSubmitButton_1ll8d_81:hover {
                    box-sizing: border-box;
                    outline: 0;
                    box-shadow: 0 0 0 calc(.1rem + var(--inputs-border-width)) #133f99 !important;
                }
            
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69,
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69 ._optionListItemSelected_1yit2_109,
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69 ._optionListItemSelected_1yit2_109>div,
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69 ._optionListItem_1yit2_99:focus-visible,
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69 ._optionListItem_1yit2_99>div:focus {
                    box-shadow: none;
                    outline: none;
                    border-radius: 0px;
                    background-color: rgb(19 63 153 / 5%);
                }
            
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69 ._optionListItem_1yit2_99 {
                    margin-bottom: 0px;
                }
            
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69 ._optionListItem_1yit2_99:hover {
                    box-shadow: none;
                    outline: none;
                    border-radius: 0px;
                    background-color: rgb(19 63 153 / 5%);
                }
            
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69 ._optionListItem_1yit2_99>div {
                    font-size: 11px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.05rem;
                    border-radius: 0px;
                }
            
                ._dropdownContainer_1yit2_60._showDownwards_1yit2_69 ._optionList_1yit2_83 {
                    padding: 8px 0px;
                }

                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formError_1ydxd_20 {
                    font-size: 11px;
                    letter-spacing: 0.04rem;
                    text-transform: uppercase;
                    font-weight: 700;
                    position: absolute;
                    padding: 0 0.5rem;
                    top: -5px; 
                    right: 2rem;
                    transition: opacity 0.3s ease;
                    display: flex;
                    color: #e02229;
                    text-align: right;
                    align-items: center;
                    justify-content: flex-end;
                    background: #F1F2EB;
                }
              
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5 textarea {
                    min-height: 12.5rem;
                    border-bottom-right-radius: 0 !important;
                    resize: vertical;
                }      
              
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 17px;
                    box-sizing: border-box;
                }
            
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form>div { 
                    box-sizing: border-box;
                    width: 100%;
                    transition: box-shadow var(--duration-short) ease;
                    outline: none;
                }            
            
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5 input,
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5 textarea {
                    box-sizing: border-box;
                    letter-spacing: 0.05rem;
                    flex-grow: 1;
                    text-align: left;
                    margin: var(--inputs-border-width);
                    height: 4.5rem;
                    position: relative;
                    line-height: calc(1 + .5 / var(--font-body-scale));
                    box-shadow: 0 0 0 var(--inputs-border-width) rgba(var(--color-foreground), var(--inputs-border-opacity));
                    padding: 2rem 1.5rem .8rem 2rem;
                }
                
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5 input:focus-visible,
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5 textarea:focus-visible { 
                    box-sizing: border-box;
                    outline: 0;
                    box-shadow: 0 0 0 calc(.1rem + var(--inputs-border-width)) #133f99 !important;
                }
                                
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5 input::placeholder {
                    opacity: 0;
                    display: none !important;
                }
            
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5 label._formInputFieldLabel_1ydxd_37 {
                    font-size: 1.3rem;
                    left: calc(var(--inputs-border-width) + 2rem);
                    right: calc(var(--inputs-border-width) + 2rem);
                    top: calc(1.2rem + var(--inputs-border-width));
                    margin-bottom: 0;
                    transition: top var(--duration-short) ease, font-size var(--duration-short) ease;
                    letter-spacing: .04rem;
                    transform: none;
                    line-height: calc(var(--inputs-border-width) + 1.4rem);
                    box-sizing: border-box;
                    font-weight: 400;
                }
            
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5 ._inputFilled_1ydxd_73,
                #form-container-ref>section._inline_stahb_47>section>div._gridItem_stahb_172._gridItemContent_stahb_257>form ._formFieldContainer_1ydxd_5:focus-within ._formInputFieldLabel_1ydxd_37 {
                    font-size: 1rem !important;
                    top: calc(var(--inputs-border-width) + .5rem) !important;
                    left: calc(var(--inputs-border-width) + 2rem) !important;
                }
            `;

            // Function to apply styles and show the form
            function applyStylesAndShow() {
                shadowRoot.appendChild(style);

                const formListener = shadowRoot.querySelector('form');

                function setErrorAttributes() {
                    const outputs = formListener.querySelectorAll('output._formError_1ydxd_20');

                    outputs.forEach((output) => {
                        const inputContainer = output.previousElementSibling;
                        if (inputContainer) {
                            const input = inputContainer.querySelector('input, textarea');
                            if (input) {
                                output.setAttribute('data-error-for', input.id || input.className);
                                inputContainer.appendChild(output);
                            }
                        }
                    });
                }

                const textareaContainer = shadowRoot.querySelector('form > div:nth-child(7)');
                if (textareaContainer) {
                    textareaContainer.classList.add('_textareaContainer');
                }

                formListener.addEventListener('submit', function (event) {
                    setErrorAttributes();
                });

                const heading = shadowRoot.querySelectorAll('h2._textHeading_2aowh_35');
                const inputs = shadowRoot.querySelectorAll('form input, form button, form placeholder');
                const phoneInput = shadowRoot.querySelectorAll('._formPhoneInputContainer_1ym3p_6');
                const locationSelector = shadowRoot.querySelectorAll('._selectContainer_1yit2_6');
                const textarea = shadowRoot.querySelectorAll('form textarea');
                const submit = shadowRoot.querySelectorAll('button._formSubmitButton_1ll8d_81');
                const textareaWrapper = shadowRoot.querySelectorAll('form > div:nth-child(7)');
                const inputWrappers = shadowRoot.querySelectorAll('form > div:not(:nth-child(7))');
                const formContainer = shadowRoot.querySelectorAll('._container_3eyaa_70');
                const successBanner = shadowRoot.querySelectorAll('._formBannerContainer_1t76a_1');
                const successHeading = shadowRoot.querySelectorAll('._formBannerHeading_1t76a_9');
                const successText = shadowRoot.querySelectorAll('._textBody_2aowh_10');              
              
                heading.forEach(value => {
                    value.style.letterSpacing = '0.15rem';
                    value.style.lineHeight = 'normal';
                    value.style.margin = '0';
                });

                inputs.forEach(value => {
                    value.addEventListener('focusout', function (event) {
                        setErrorAttributes();
                    });
                });

                phoneInput.forEach(value => {
                    value.style.gridTemplateColumns = '1fr';
                    value.style.display = 'grid';
                });

                locationSelector.forEach(value => {
                    value.style.display = 'none';
                });

                textarea.forEach(value => {
                    value.addEventListener('focusout', function (event) {
                        setErrorAttributes();
                    });
                });

                submit.forEach(value => {
                    value.style.boxSizing = 'border-box';
                    value.style.outline = '0';
                    value.style.letterSpacing = '0.1rem';
                    value.style.textTransform = 'uppercase';
                    value.style.marginTop = '5px';
                    value.style.fontSize = '1.3rem';
                    value.style.fontWeight = '400';
                    value.style.transition = 'border-box 0.1s ease';
                    value.style.lineHeight = '1';
                    value.style.alignItems = 'center';
                    value.style.padding = 'calc(var(--button-padding) + 2px)';
                    value.style.width = 'var(--submit-button-width)';
                    value.style.gridColumn = 'var(--text-area-column-span)';
                    value.style.padding = '0 3rem';
                    value.style.minHeight = 'calc(4rem + var(--buttons-border-width)* 2)';
                });

                formContainer.forEach(value => {
                    value.style.display = 'var(--form-block-display)';
                });

                textareaWrapper.forEach(value => {
                    value.style.gridColumn = 'var(--text-area-column-span)';
                });

                inputWrappers.forEach(value => {
                    value.style.gridColumn = 'var(--input-column-span)';
                });

                setErrorAttributes();
              
                setTimeout(() => {
                    if (outerContainer) {
                        outerContainer.style.opacity = '1';
                    }
                }, 100);
            }

             const formContainer = shadowRoot.querySelector('#form-container-ref');
            if (formContainer) {
                applyStylesAndShow();
                return;
            }

            // Use MutationObserver to detect when the form is fully loaded
            const observer = new MutationObserver((mutations, obs) => {
                const formContainer = shadowRoot.querySelector('#form-container-ref');
                if (formContainer) {
                    obs.disconnect();
                    applyStylesAndShow();
                }
            });

            
            observer.observe(shadowRoot, {
                childList: true,
                subtree: true
            });

           setTimeout(() => {
                if (!shadowRoot.querySelector('#form-container-ref.loaded')) {
                    observer.disconnect();
                    applyStylesAndShow();
                }
            }, 5000);
          
        } catch (error) {
            console.error('Error modifying form inputs:', error);
        }
    }
  checkAndInitializeForm();
});
